import React from 'react'
import PropTypes from 'prop-types'

import { Dropdown } from 'react-bootstrap'

const DropdownButton = ({
  id,
  show, // optional (if manual control is needed for show/toggle)
  toggle, // optional
  variant = 'primary',
  outline = false,
  ghost = false,
  size = 'md',
  block = false,
  disabled = false,
  loading = false,
  className = '',
  arrow = false,
  options = [],
  stickyItems,
  // tooltip,
  // tooltipPlacement,
  children
}) => {
  let colorClass = 'btn-'
  if (outline) {
    colorClass += 'outline-'
  } else if (ghost) {
    colorClass += 'ghost-'
  }
  colorClass += variant

  let dropdownToggleContent = (
    <Dropdown.Toggle
      as='button'
      type='button'
      id={id}
      size={size}
      disabled={loading || disabled}
      className={`btn btn-${size} ${colorClass} ${arrow ? '' : 'no-arrow'} ${className}`}
    >
      {loading
        ? <span><span className='fas fa-spinner fa-spin me-2' />Loading...</span>
        : children
      }
    </Dropdown.Toggle>
  )

  // if (tooltip) {
  //   dropdownToggleContent = (
  //     <ToolTip
  //       trigger='hover'
  //       id={`${useId()}-tooltip`}
  //       text={tooltip}
  //       placement={tooltipPlacement}
  //     >
  //       {dropdownToggleContent}
  //     </ToolTip>
  //   )
  // }

  if (block) {
    dropdownToggleContent = (
      <div className='d-grid'>
        {dropdownToggleContent}
      </div>
    )
  }

  return (
    <Dropdown
      show={show}
      onToggle={(nextShow) => {
        if (toggle) toggle(nextShow)
      }}
    >
      {dropdownToggleContent}
      <Dropdown.Menu
        popperConfig={{ strategy: 'fixed' }}
        renderOnMount
        bsPrefix={stickyItems ? 'dropdown-menu p-0' : 'dropdown-menu'}
      >
        {stickyItems && <Dropdown.ItemText bsPrefix='dropdown-item-text sticky-search py-2 border-bottom'>{stickyItems}</Dropdown.ItemText>}
        <div className={stickyItems ? 'sticky-dropmenu-menu-column' : 'dropdown-menu-column'}>
          {options.map((d, i) => (d.divider
            ? <Dropdown.Divider key={i} />
            : d.text
              ? <Dropdown.ItemText key={i}>{d.content}</Dropdown.ItemText>
              : <Dropdown.Item key={i} onClick={d.onClick} disabled={d.disabled}>{d.content}</Dropdown.Item>))}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  )
}

DropdownButton.propTypes = {
  id: PropTypes.string,
  show: PropTypes.bool,
  toggle: PropTypes.func,
  variant: PropTypes.string,
  outline: PropTypes.bool,
  ghost: PropTypes.bool,
  size: PropTypes.string,
  block: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  className: PropTypes.string,
  arrow: PropTypes.bool,
  options: PropTypes.array,
  // tooltip: PropTypes.string,
  // tooltipPlacement: PropTypes.string,
  children: PropTypes.any,
  stickyItems: PropTypes.any
}

export default DropdownButton
